import React from 'react';
import PropTypes from 'prop-types';

const FormSection = ({ title, children, style, titleStyle }) => (
  <div className="form-section" style={style}>
    {title && (
      <>
        <h5 className="form-title" style={titleStyle}>
          {title}
        </h5>
        <hr className="form-separator" />
      </>
    )}
    {children}
  </div>
);

FormSection.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  titleStyle: PropTypes.object,
};

FormSection.defaultProps = {
  style: null,
  titleStyle: null,
};

export default FormSection;
